import { useState, useEffect, useContext, useMemo } from "react";
import {
  useHistory,
  useLocation,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min.js";
import Module from "./Module.jsx";
import { LearningContentLayout } from "../../shared/ui/Learning/LearningContentLayout.jsx";
import { ChapterList } from "../../shared/domain/learning/components/ChapterList.jsx";

import { GlobalContext } from "../../context/GlobalState.jsx";

import { decodeHTMLEntities } from "../../shared/utils/url.js";
import { groupModulesByCategory } from "../../utils/tools.js";

export default function Chapters(props) {
  const { userDetails, setUserDetails } = useContext(GlobalContext);
  const history = useHistory();
  const location = useLocation();
  const params = useParams();

  const subjectId = props?.match?.params?.subjectId;
  const [pageData, setPageData] = useState({
    chapters: [],
    loading: true,
  });
  const [modules, setModules] = useState({
    modules: [],
    loading: true,
  });

  const { chapters, loading } = pageData;
  const selectedSubject = params["subject"] || "Chapters";

  function openChapter(chapter) {
    history.push(
      `${window.location.pathname}/${decodeHTMLEntities(chapter.name)}/${
        chapter._id
      }`,
    );
  }

  useEffect(() => {
    if (!subjectId) return;
    fetch(`${process.env.REACT_APP_ORIGIN}/api/v1/subjects/${subjectId}`, {
      headers: {
        token: `${window.localStorage.getItem("authToken")}`,
      },
    })
      .then((response) => response.json())
      .then((response) => {
        console.log(response);

        let chapters = response?.data?.subject?.totalChapters
          ? response?.data?.subject?.chapters.filter(
              (item) => item.lang === window.localStorage.getItem("language"),
            )
          : [];
        setPageData((data) => ({
          ...data,
          loading: false,
          chapters: chapters || [],
        }));
      })
      .catch((e) =>
        setPageData((data) => ({
          ...data,
          loading: false,
        })),
      );
  }, []);

  useEffect(() => {
    const grade = window.localStorage.getItem("grade");
    const section = window.localStorage.getItem("section");
    const language = window.localStorage.getItem("language") || "english";
    const tempOrigin = "https://api.2xcell.in";
    fetch(
      `${tempOrigin}/api/v1/grades/${grade}/sections/${section}/topics/${subjectId}/modules?lang=${language}&folder=subject`,
      {
        headers: {
          token: `${window.localStorage.getItem("authToken")}`,
        },
      },
    )
      .then((response) => response.json())
      .then((response) => {
        const modules = response?.data?.modules || [];
        setModules({
          loading: false,
          modules: modules,
        });
      })
      .catch((e) =>
        setModules((data) => ({
          ...data,
          loading: false,
        })),
      );
  }, []);

  const updateQuery = (key, value) => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.set(key, value);
    history.push({ search: searchParams.toString() });
  };

  const getQuery = (key) => {
    const params = new URLSearchParams(location.search);
    return params.get(key);
  };

  const folder = useMemo(() => {
    return getQuery("folder") || "chapter";
  }, [location]);

  const groupedModules = useMemo(() => {
    return groupModulesByCategory(modules.modules);
  }, [modules]);

  useEffect(() => {
    setUserDetails({ ...userDetails, selectedTab: "2Xcell Resources" });
    setUserDetails({
      ...userDetails,
      selectedPath: {
        subject: selectedSubject,
        chapter: "",
        topic: "",
      },
    });
  }, []);

  return (
    <LearningContentLayout
      grade={`${userDetails.grade} - ${userDetails.section}`}
      resourcePage={selectedSubject}
    >
      <div
        className="button_container"
        style={{
          justifyContent: "space-between",
          display: modules.modules.length ? "flex" : "none",
        }}
      >
        <button
          type="button"
          className={folder === "chapter" ? "selected_language" : ""}
          onClick={() => {
            updateQuery("folder", "chapter");
          }}
        >
          CHAPTERS
        </button>
        <button
          type="button"
          className={folder === "module" ? "selected_language" : ""}
          onClick={() => {
            updateQuery("folder", "module");
          }}
        >
          TEACHER RESOURCES
        </button>
      </div>

      {folder === "chapter" ? (
        <ChapterList loading={loading} chapters={chapters} onClick={openChapter} />
      ) : (
        groupedModules.map((mod) => {
          return (
            <Module
              heading={mod.categoryName}
              hide={mod.modules.length ? false : true}
              modules={mod.modules}
              fetched={[]}
            />
          );
        })
      )}
    </LearningContentLayout>
  );
}
